import {
    Box, Button, Text, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Flex, Image, Input, Select, VStack, HStack, Link, Checkbox, Spinner, Icon, IconButton, Grid, GridItem, Collapse, FormControl, FormLabel, useDisclosure, useToast, Menu, MenuButton, MenuList, MenuItem, MenuGroup, MenuDivider, Portal
} from '@chakra-ui/react';
import React, { useState, useMemo, useRef, useLayoutEffect, memo } from 'react';
import {
    Eye, EllipsisVertical, StickyNote, NotebookPen, Bookmark, MessageCircle, Clock, User, Phone, Mail, IdCard, FileText, Truck, Package, ExternalLink, ChevronDown, ChevronUp, Pencil, Download, Tag, TriangleAlert, CircleCheck, PackageOpen, CircleX, Minus, ClipboardCheck, ZoomIn, Undo2
} from 'lucide-react';
import { format, parseISO } from 'date-fns';
import ProdutoImagem from "../ProdutoImagem";
import ListaCompraStatusBadge from "../ListaCompraStatusBadge";
import AdicionarItemListaModal from "../AdicionarItemListaModal";
import StatusConferenciaBadge from "../StatusConferenciaBadge";
import GeradorEtiquetaMelhorEnvio from '../GeradorEtiquetaMelhorEnvio';
import Notas from "../Notas";
import DetalhesVendaModal from "./DetalhesVendaModal";
import { isColetaMl } from "../../utils/envioMl";
import { formatPhone } from "../Crm/crmUtils";
import { atualizarClienteVenda, atualizarDataLimiteEnvio, getDadosEntregaCombinar, confirmarEntregaCombinar } from "../../services/api";
import { useAcoesItemVenda, SelosOcorrenciasItem, LinhasExtrato, podeItemSerCancelado } from "../OcorrenciasItemVenda";

import {
    STATUS_TAGA, STATUS_MARKETPLACE, MARCADORES, COTACAO, CANAIS, FORNECEDOR_LOGO, LISTA_ICONE, CONFERENCIA_SELO, NUMEROS, COLUNAS_ITEM, ROLAGEM_ITENS, linkAnuncioMl, ROTULO_SECAO, LARANJA, COR_ROTULO, FUNDO_LATERAL, SOMBRA, SOMBRA_HOVER, isMercadoLivre, paraNumero, brl, situacaoPrazo, normalizarTipoCliente, formatarDocumento, DicaSePuder, Selo, BotaoCopiar, TextoCopiavel, BotaoAcao, Secao, LinhaContato, Canal, SeloOcorrencia, LinhaExtrato
} from './ui';

const VendaCardV2 = ({
    pedido,
    isMobile,
    checkboxesState,
    handleCheckboxChange,
    menuVisivel,
    toggleMenu,
    handleChangeAcaoIndiv,
    openTicketModal,
    handleAddObs,
    handleChangeTextObs,
    textObs,
    handleApagarObs,
    handleMarcadorTaga,
    consultarMensagensVendas,
    naoLidasPorPackId = {},
    handleClickCopyPedido,
    handleClickCopyAnuncio,
    loadingItemsEtiqueta,
    handleClickImprimirEtiqueta,
    loadingItemsNFML,
    openModalConfirmNF,
    openModalConfirmNfeTaga,
    openPedidosFooter,
    toggleAccordionPedidosFooter,
    onOcorrenciasAlteradas,
    checkPermission,
    isInPackGroup = false,
    somenteFicha = false,
    onFecharFicha,
    cotacaoStatus,
}) => {
    const toast = useToast();
    const [expandidos, setExpandidos] = useState({});
    const [imagemAmpliada, setImagemAmpliada] = useState(null);
    const [detalhesAberto, setDetalhesAberto] = useState(somenteFicha);
    const [versaoDetalhes, setVersaoDetalhes] = useState(0);
    const refLista = useRef(null);
    const [alturaLista, setAlturaLista] = useState(null);
    const [fimLista, setFimLista] = useState(false);

    useLayoutEffect(() => {
        const lista = refLista.current;
        if (!lista || (pedido.produtos || []).length <= 2) {
            setAlturaLista(null);
            return undefined;
        }
        const linhas = Array.from(lista.children).slice(0, 2);
        const medir = () => setAlturaLista(linhas.reduce((soma, el) => soma + el.offsetHeight, 0));
        medir();
        const observador = new ResizeObserver(medir);
        linhas.forEach((el) => observador.observe(el));
        return () => observador.disconnect();
    }, [pedido.produtos]);

    const [localCliente, setLocalCliente] = useState(null);
    const { isOpen: isClienteModalOpen, onOpen: onClienteModalOpen, onClose: onClienteModalClose } = useDisclosure();
    const [clienteForm, setClienteForm] = useState({ nome: '', nickname: '', tipo: 'PF', documento: '', ie: '', email: '', telefone: '' });
    const [savingCliente, setSavingCliente] = useState(false);

    const { isOpen: isEntregaModalOpen, onOpen: onEntregaModalOpen, onClose: onEntregaModalClose } = useDisclosure();
    const [entregaForm, setEntregaForm] = useState({ nome: '', telefone: '', documento: '', tipo: 'PF', cep: '', endereco: '', numero: '', complemento: '', bairro: '', cidade: '', uf: '', transportadora: '' });
    const [savingEntrega, setSavingEntrega] = useState(false);
    const [loadingEntrega, setLoadingEntrega] = useState(false);
    const isEntregaCombinar = pedido?.envio?.modo_envio === 'Entrega a Combinar';

    const [localDataLimiteEnvio, setLocalDataLimiteEnvio] = useState(null);
    const { isOpen: isPrazoModalOpen, onOpen: onPrazoModalOpen, onClose: onPrazoModalClose } = useDisclosure();
    const { isOpen: isPrazoConfirmOpen, onOpen: onPrazoConfirmOpen, onClose: onPrazoConfirmClose } = useDisclosure();
    const [prazoForm, setPrazoForm] = useState("");
    const [prazoConfirmacaoTexto, setPrazoConfirmacaoTexto] = useState("");
    const [savingPrazo, setSavingPrazo] = useState(false);
    const dataLimiteEnvioAtual = localDataLimiteEnvio ?? pedido?.data_limite_envio;

    const [modalListaInfo, setModalListaInfo] = useState(null);
    const [listaStatusOverrides, setListaStatusOverrides] = useState({});

    const ehMl = isMercadoLivre(pedido.origem);
    const ehTagaOuSite = pedido.origem === "TAGA" || pedido.origem === "ECOMMERCE";
    const numeroPedido = pedido.origem === "TAGA" ? pedido.id_taga : pedido.id;
    const clienteAtual = localCliente ?? pedido?.dados_cliente;
    const marcador = MARCADORES[pedido.marcador];
    const statusTaga = STATUS_TAGA[pedido.status_taga];
    const statusMkt = STATUS_MARKETPLACE[pedido.status];
    const vendaCancelada = Number(pedido.status_taga) === 2 || pedido.status === "CANCELADA";
    const cotacao = cotacaoStatus?.token ? COTACAO[cotacaoStatus.status] : null;
    const podeAgir = checkPermission();
    const acoesItem = useAcoesItemVenda({ onAlterado: onOcorrenciasAlteradas });
    const notaEmitida = pedido.notaEmitida === true || Number(pedido.notaEmitida) === 1;
    const notaPendente = pedido.notaEmitida === false || pedido.notaEmitida === 0 || pedido.notaEmitida === "0";

    const statusMsg = naoLidasPorPackId[String(pedido?.pack_id)] || {};
    const msgLabel = statusMsg.nao_lida
        ? (statusMsg.qtd > 0 ? `${statusMsg.qtd} mensagem(ns) não lida(s)` : 'Mensagens não lidas')
        : (statusMsg.tem_historico ? 'Chat com mensagens' : 'Chat com Cliente');

    const avisoEntregaMl = useMemo(() => {
        if (pedido?.ml_entrega_avisada_at) {
            let quando = '';
            try {
                quando = format(parseISO(pedido.ml_entrega_avisada_at.replace(' ', 'T')), "dd/MM/yyyy 'às' HH:mm");
            } catch {
                quando = '';
            }
            return {
                rotulo: 'ENTREGA AVISADA NO ML',
                descricao: quando
                    ? `Entrega confirmada no Mercado Livre em ${quando}. O pagamento foi liberado.`
                    : 'Entrega confirmada no Mercado Livre. O pagamento foi liberado.',
                scheme: 'green',
                icone: CircleCheck,
            };
        }
        if (pedido?.ml_entrega_aviso_erro) {
            return {
                rotulo: 'FALHA AO AVISAR O ML',
                descricao: `Não foi possível avisar a entrega ao Mercado Livre: ${pedido.ml_entrega_aviso_erro}. O sistema tenta de novo automaticamente.`,
                scheme: 'red',
                icone: TriangleAlert,
            };
        }
        return null;
    }, [pedido?.ml_entrega_avisada_at, pedido?.ml_entrega_aviso_erro]);


    const handleOpenListaModal = (produto, statusAtual) => {
        if (!produto?.item_venda_id || !produto?.fornecedor_id) return;
        setModalListaInfo({
            itemVendaId: produto.item_venda_id,
            fornecedorId: produto.fornecedor_id,
            fornecedorNome: produto.fornecedor,
            produtoNome: produto.nome,
            statusAtual,
        });
    };

    const handleListaUpdated = (novoStatus) => {
        if (!modalListaInfo) return;
        const itemId = modalListaInfo.itemVendaId;
        setListaStatusOverrides((prev) => ({ ...prev, [itemId]: novoStatus && novoStatus.status ? novoStatus : null }));
    };

    const resolverListaStatus = (produto) => {
        const itemId = produto?.item_venda_id;
        if (itemId && Object.prototype.hasOwnProperty.call(listaStatusOverrides, itemId)) {
            return listaStatusOverrides[itemId];
        }
        return produto?.lista_compra_status ?? null;
    };

    const handleOpenClienteModal = () => {
        setClienteForm({
            nome: clienteAtual?.nome || '',
            nickname: clienteAtual?.nickname || '',
            tipo: normalizarTipoCliente(clienteAtual?.tipo),
            documento: clienteAtual?.documento || '',
            ie: clienteAtual?.ie || '',
            email: clienteAtual?.email || '',
            telefone: clienteAtual?.telefone || '',
        });
        onClienteModalOpen();
    };

    const handleSalvarCliente = async () => {
        if (!clienteForm.nome?.trim()) {
            toast({ title: 'Nome é obrigatório', status: 'warning', duration: 3000, isClosable: true });
            return;
        }
        setSavingCliente(true);
        try {
            const res = await atualizarClienteVenda(pedido.id_taga ?? pedido.id, clienteForm);
            if (res?.data?.status) {
                setLocalCliente(res.data.data);
                setVersaoDetalhes((v) => v + 1);
                onClienteModalClose();
                toast({ title: 'Cliente atualizado com sucesso', status: 'success', duration: 3000, isClosable: true });
            } else {
                toast({ title: 'Erro ao salvar cliente', description: res?.data?.error || '', status: 'error', duration: 4000, isClosable: true });
            }
        } catch (e) {
            toast({ title: 'Erro ao salvar cliente', status: 'error', duration: 4000, isClosable: true });
        } finally {
            setSavingCliente(false);
        }
    };

    const handleOpenEntregaModal = async () => {
        const c = clienteAtual || {};
        setEntregaForm({
            nome: c.nome || c.nickname || '',
            telefone: c.telefone || '',
            documento: c.documento || '',
            tipo: normalizarTipoCliente(c.tipo),
            cep: '', endereco: '', numero: '', complemento: '', bairro: '', cidade: '', uf: '',
            transportadora: pedido?.transportadora_combinada || '',
        });
        onEntregaModalOpen();
        setLoadingEntrega(true);
        try {
            const res = await getDadosEntregaCombinar(pedido.id_taga ?? pedido.id);
            if (res?.data?.status) {
                const { cliente, endereco, transportadora_combinada } = res.data.data;
                setEntregaForm({
                    nome: cliente?.nome || cliente?.nickname || c.nome || c.nickname || '',
                    telefone: cliente?.telefone || c.telefone || '',
                    documento: cliente?.documento || c.documento || '',
                    tipo: normalizarTipoCliente(cliente?.tipo ?? c.tipo),
                    cep: endereco?.cep || '',
                    endereco: endereco?.endereco || '',
                    numero: endereco?.numero || '',
                    complemento: endereco?.complemento || '',
                    bairro: endereco?.bairro || '',
                    cidade: endereco?.cidade || '',
                    uf: endereco?.uf || '',
                    transportadora: transportadora_combinada || pedido?.transportadora_combinada || '',
                });
            }
        } catch (e) {
        } finally {
            setLoadingEntrega(false);
        }
    };

    const handleSalvarEntrega = async () => {
        if (!entregaForm.nome?.trim()) {
            toast({ title: 'Nome é obrigatório', status: 'warning', duration: 3000, isClosable: true });
            return;
        }
        setSavingEntrega(true);
        try {
            const res = await confirmarEntregaCombinar(pedido.id_taga ?? pedido.id, entregaForm);
            if (res?.data?.status) {
                const { cliente, transportadora_combinada } = res.data.data;
                pedido.status_taga = 1;
                pedido.furo_estoque = 0;
                pedido.marcador = 0;
                pedido.transportadora_combinada = transportadora_combinada;
                setLocalCliente(cliente);
                setVersaoDetalhes((v) => v + 1);
                onEntregaModalClose();
                toast({ title: 'Dados de entrega confirmados', description: 'Venda marcada como CONFIRMADA', status: 'success', duration: 3000, isClosable: true });
            } else {
                toast({ title: 'Erro ao confirmar entrega', description: res?.data?.error || '', status: 'error', duration: 4000, isClosable: true });
            }
        } catch (e) {
            toast({ title: 'Erro ao confirmar entrega', status: 'error', duration: 4000, isClosable: true });
        } finally {
            setSavingEntrega(false);
        }
    };

    const handleOpenPrazoModal = () => {
        const match = typeof dataLimiteEnvioAtual === 'string'
            ? dataLimiteEnvioAtual.match(/^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})/)
            : null;
        setPrazoForm(match ? `${match[3]}-${match[2]}-${match[1]}T${match[4]}:${match[5]}` : "");
        onPrazoModalOpen();
    };

    const handleConfirmarPrazo = () => {
        if (!prazoForm) {
            toast({ title: 'Informe a nova data', status: 'warning', duration: 3000, isClosable: true });
            return;
        }
        const escolhida = new Date(prazoForm);
        if (isNaN(escolhida.getTime())) {
            toast({ title: 'Data inválida', status: 'error', duration: 3000, isClosable: true });
            return;
        }
        if (escolhida <= new Date()) {
            toast({ title: 'A data precisa ser no futuro', status: 'warning', duration: 3000, isClosable: true });
            return;
        }
        setPrazoConfirmacaoTexto(escolhida.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }));
        onPrazoConfirmOpen();
    };

    const handleSalvarPrazo = async () => {
        setSavingPrazo(true);
        try {
            const res = await atualizarDataLimiteEnvio(pedido.id_taga ?? pedido.id, prazoForm);
            if (res?.success) {
                const novoDisplay = res.data_limite_envio_display;
                setLocalDataLimiteEnvio(novoDisplay);
                setVersaoDetalhes((v) => v + 1);
                pedido.data_limite_envio = novoDisplay;
                if (pedido.envio) {
                    pedido.envio.data_limite_envio = res.data_limite_envio;
                }
                onPrazoConfirmClose();
                onPrazoModalClose();
                toast({ title: 'Prazo de envio atualizado', status: 'success', duration: 3000, isClosable: true });
            } else {
                toast({ title: 'Erro ao salvar prazo', description: res?.error || '', status: 'error', duration: 4000, isClosable: true });
            }
        } catch (e) {
            toast({ title: 'Erro ao salvar prazo', status: 'error', duration: 4000, isClosable: true });
        } finally {
            setSavingPrazo(false);
        }
    };

    const chaveItem = (produto, i) => produto.item_venda_id ?? `${produto.id}-${i}`;
    const alternarItem = (chave) => setExpandidos(prev => ({ ...prev, [chave]: !prev[chave] }));

    const menuAberto = menuVisivel === pedido.id;
    const totalAberto = !!openPedidosFooter[pedido.id];

    const resumoItem = (produto) => {
        const ocorrencias = Array.isArray(produto.ocorrencias) ? produto.ocorrencias : [];
        const somar = (tipo) => ocorrencias.filter((o) => o.tipo === tipo).reduce((t, o) => t + (paraNumero(o.quantidade) || 0), 0);
        const qtd = paraNumero(produto.quantidade) || 0;
        const cancelada = somar('cancelamento');
        const devolvida = somar('devolucao');
        return { ocorrencias, qtd, cancelada, devolvida, efetiva: Math.max(0, qtd - cancelada - devolvida) };
    };

    const valores = (() => {
        if (pedido.extrato) {
            const e = pedido.extrato;
            return { bruto: e.valor_bruto, cancelados: e.cancelados, devolvidos: e.devolvidos, outros: e.outros_reembolsos, total: e.total_realizado, realizado: e.total_realizado, temOcorrencia: true };
        }
        let bruto = 0;
        let cancelados = 0;
        let devolvidos = 0;
        (pedido.produtos || []).forEach((p) => {
            const preco = paraNumero(p.preco) || 0;
            const r = resumoItem(p);
            bruto += preco * r.qtd;
            cancelados += preco * r.cancelada;
            devolvidos += preco * r.devolvida;
        });
        const desconto = paraNumero(pedido.desconto) || 0;
        const outros = paraNumero(pedido.outros_reembolsos) || 0;
        const total = paraNumero(pedido.total) || 0;
        const frete = total - (bruto - desconto);
        const temOcorrencia = cancelados > 0 || devolvidos > 0 || outros > 0;
        return { bruto, cancelados, devolvidos, desconto, outros, frete: Math.abs(frete) < 0.005 ? 0 : frete, total, realizado: total - cancelados - devolvidos - outros, temOcorrencia };
    })();

    const renderItem = (produto, i) => {
        const chave = chaveItem(produto, i);
        const aberto = !!expandidos[chave];
        const preco = paraNumero(produto.preco);
        const qtd = paraNumero(produto.quantidade) || 0;
        const temPromo = !!produto.promocao_lista_id;
        const r = resumoItem(produto);
        const foraDoPedido = r.qtd > 0 && r.efetiva === 0;
        const alterado = r.cancelada > 0 || r.devolvida > 0;
        return (
            <Grid key={chave} templateColumns={COLUNAS_ITEM} columnGap={{ base: 3, md: 4 }} rowGap={2}
                px={{ base: 3, md: 5 }} py={3} borderBottom="1px solid" borderColor="gray.200" _last={{ borderBottom: 0 }} alignItems="start">
                <VStack spacing={1.5} align="stretch">
                    <DicaSePuder desativado={isMobile} label="Ampliar imagem">
                        <Box as="button" type="button" aria-label="Ampliar imagem do produto" position="relative" data-group cursor="zoom-in"
                            borderRadius="lg" border="1px solid" borderColor="gray.100" overflow="hidden" bg="white" w={{ base: "52px", md: "60px", xl: "64px" }} h={{ base: "52px", md: "60px", xl: "64px" }}
                            _hover={{ borderColor: "gray.300" }} onClick={(e) => { e.stopPropagation(); setImagemAmpliada(produto); }}>
                            <ProdutoImagem produto={produto} origem="" width={isMobile ? "50px" : "62px"} height={isMobile ? "50px" : "62px"} />
                            <Flex position="absolute" inset={0} align="center" justify="center" bg="blackAlpha.400" color="white" opacity={0} _groupHover={{ opacity: 1 }} transition="opacity .15s">
                                <Icon as={ZoomIn} boxSize="18px" />
                            </Flex>
                        </Box>
                    </DicaSePuder>
                    <DicaSePuder desativado={isMobile} label={`Fornecedor: ${produto.fornecedor}`}>
                        <Flex align="center" justify="center" h="26px" px={1} bg="white" border="1px solid" borderColor="gray.200" borderRadius="md">
                            <Image loading="lazy" decoding="async" src={FORNECEDOR_LOGO[produto.fornecedor] || "/logo_vannucci.webp"} alt={produto.fornecedor} maxH="18px" maxW="100%" w="auto" objectFit="contain" />
                        </Flex>
                    </DicaSePuder>
                </VStack>

                <Box minW={0}>
                    <Flex align="flex-start" gap={1} minW={0}>
                        <TextoCopiavel valor={produto.nome} desativarDica={isMobile} semIcone flex="1" minW={0}>
                            <Text as="span" fontSize="14px" fontWeight="600" color={foraDoPedido ? "gray.400" : "inherit"} textDecoration={foraDoPedido ? "line-through" : "none"} noOfLines={2} letterSpacing="-0.005em">{produto.nome}</Text>
                        </TextoCopiavel>
                        <IconButton aria-label="Mais detalhes do item" size="xs" variant="ghost" color="gray.400" flex="none" borderRadius="md"
                            icon={<Icon as={aberto ? ChevronUp : ChevronDown} boxSize="14px" />} onClick={() => alternarItem(chave)} />
                        {podeItemSerCancelado(pedido, produto, podeAgir) && (
                            <Menu placement="bottom-end" isLazy>
                                <MenuButton as={IconButton} aria-label="Ações do item" size="xs" variant="ghost" color="gray.400" flex="none" borderRadius="md"
                                    icon={<Icon as={EllipsisVertical} boxSize="14px" />} />
                                <Portal>
                                    <MenuList zIndex={1500} fontSize="sm" py={1.5} minW="220px" borderRadius="lg" boxShadow="lg">
                                        <Text px={3} pb={1.5} pt={0.5} fontSize="10px" fontWeight="700" letterSpacing="0.08em" textTransform="uppercase" color="gray.500">Item</Text>
                                        <MenuItem onClick={() => acoesItem.abrirCancelar(pedido, produto)}
                                            icon={<Icon as={CircleX} boxSize="15px" color="red.500" />}>Cancelar item</MenuItem>
                                    </MenuList>
                                </Portal>
                            </Menu>
                        )}
                    </Flex>

                    <Flex wrap="wrap" align="center" columnGap={2} rowGap={1} mt={0.5} fontSize="12px" color="gray.500">
                        <HStack spacing={1}>
                            <Text>SKU</Text>
                            <TextoCopiavel valor={produto.id} desativarDica={isMobile} color="gray.800" fontWeight="600" fontFamily="mono" fontSize="12px">{produto.id}</TextoCopiavel>
                            <Link href={`${window.location.origin}/produtos?id=${produto.id}`} isExternal color="gray.400" display="inline-flex" aria-label="Abrir produto" _hover={{ color: "blue.600" }}>
                                <Icon as={ExternalLink} boxSize="11px" />
                            </Link>
                        </HStack>
                        <Text color="gray.300">•</Text>
                        <HStack spacing={1}><Text>Global</Text>{produto.codigo
                            ? <TextoCopiavel valor={produto.codigo} desativarDica={isMobile} color="gray.800" fontWeight="600" fontFamily="mono" fontSize="12px">{produto.codigo}</TextoCopiavel>
                            : <Text color="gray.800" fontWeight="600" fontSize="12px">-</Text>}</HStack>
                        <Text color="gray.300">•</Text>
                        <HStack spacing={1}><Text>Fab.</Text><Text color="gray.800" fontWeight="600">{produto.fabricante || '-'}</Text></HStack>
                    </Flex>

                    <Flex wrap="wrap" gap={1.5} mt={2} align="center">
                        <ListaCompraStatusBadge listaCompraStatus={resolverListaStatus(produto)} onClickSemLista={(info) => handleOpenListaModal(produto, info?.status)}
                            renderizar={({ statusKey, scheme, texto, listaId, dica, clicavel, onClick }) => (
                                <DicaSePuder desativado={isMobile} label={dica}>
                                    <Selo as={clicavel ? "button" : "span"} type={clicavel ? "button" : undefined} cursor={clicavel ? "pointer" : "default"} onClick={onClick}
                                        scheme={scheme} icone={LISTA_ICONE[statusKey] || Minus} _hover={clicavel ? { filter: "brightness(0.97)" } : undefined}>
                                        {statusKey === 'sem_status' ? 'Sem lista' : statusKey === 'ignorado' ? 'Lista ignorada' : `Lista${listaId ? ` #${listaId}` : ''} · ${texto}`}
                                    </Selo>
                                </DicaSePuder>
                            )} />
                        {!foraDoPedido && <StatusConferenciaBadge status={produto.conferencia_status} vendaId={pedido.id_taga} produtoEstoqueId={produto.id}
                            renderizar={({ status, scheme, texto, clicavel, carregando, onClick }) => {
                                const selo = CONFERENCIA_SELO[status] || { texto: "Conferido", icone: ClipboardCheck };
                                return (
                                    <DicaSePuder desativado={isMobile} label={clicavel ? `${texto} · ver detalhes` : texto}>
                                        <Selo as={clicavel ? "button" : "span"} type={clicavel ? "button" : undefined} cursor={clicavel ? "pointer" : "default"} onClick={onClick}
                                            scheme={scheme} forte={status === 2} icone={carregando ? undefined : selo.icone} _hover={clicavel ? { filter: "brightness(0.97)" } : undefined}>
                                            {carregando && <Spinner size="xs" />}
                                            {selo.texto}
                                        </Selo>
                                    </DicaSePuder>
                                );
                            }} />}
                        {Number(produto.furo_estoque) === 1 && <Selo scheme="red" forte icone={PackageOpen}>Furo de estoque</Selo>}
                        {Number(produto.furo_estoque) !== 1 && Number(produto.furo_estoque_coberto) === 1 && <Selo scheme="green" icone={CircleCheck}>Furo coberto</Selo>}
                    </Flex>

                    {r.ocorrencias.length > 0 && (
                        <SelosOcorrenciasItem pedido={pedido} produto={produto} acoes={acoesItem} podeAgir={podeAgir} Selo={SeloOcorrencia} desativarDica={isMobile} mostrarCancelar={false} />
                    )}

                    <Collapse in={aberto} animateOpacity>
                        <Grid mt={3} p={3} bg="gray.50" border="1px solid" borderColor="gray.100" borderRadius="lg" fontSize="12px"
                            templateColumns={{ base: "1fr", md: "repeat(3, auto)" }} justifyContent="start" columnGap={6} rowGap={2}>
                            <Box><Text color="gray.500" fontSize="11px">Código fabricante</Text><Text color="gray.800" fontWeight="600" fontFamily="mono">{produto.codigo_fabricante || '-'}</Text></Box>
                            <Box><Text color="gray.500" fontSize="11px">Código fornecedor</Text><Text color="gray.800" fontWeight="600" fontFamily="mono">{produto.codigo_fornecedor || '-'}</Text></Box>
                            <Box>
                                <Text color="gray.500" fontSize="11px">ID anúncio</Text>
                                <HStack spacing={1}>
                                    <Text color="gray.800" fontWeight="600" fontFamily="mono">{produto.id_ml || '-'}</Text>
                                    {produto.id_ml && (
                                        <BotaoCopiar valor={produto.id_ml} onCopiar={handleClickCopyAnuncio} label="Copiar ID do anúncio" tamanho="12px" />
                                    )}
                                    {produto.id_ml && ehMl && (
                                        <Link href={linkAnuncioMl(produto.id_ml)} isExternal aria-label="Abrir anúncio no Mercado Livre" color="gray.400" _hover={{ color: "blue.600" }} display="inline-flex">
                                            <Icon as={ExternalLink} boxSize="12px" />
                                        </Link>
                                    )}
                                </HStack>
                            </Box>
                        </Grid>
                    </Collapse>
                </Box>

                <Flex gridColumn={{ base: "2", md: "auto" }} direction={{ base: "row", md: "column" }} align="center" justify={{ base: "flex-start", md: "flex-start" }}
                    gap={{ base: 2, md: 0 }} pt={{ md: 0.5 }}>
                    <Flex direction="column" align="center" justify="center" minW={{ base: "auto", md: "52px" }} w={{ md: "100%" }} h={{ base: "auto", md: "52px" }}
                        px={{ base: 2.5, md: 0 }} py={{ base: 1, md: 0 }} borderRadius="lg" bg="orange.50" border="1px solid" borderColor="orange.200"
                        flexDirection={{ base: "row", md: "column" }} gap={{ base: 1, md: 0 }}>
                        <Text fontSize={{ base: "14px", md: "18px" }} fontWeight="800" color={foraDoPedido ? "gray.400" : "orange.700"} lineHeight="1" sx={NUMEROS}>{alterado ? r.efetiva : qtd}</Text>
                        <Text fontSize="10px" fontWeight="600" color={foraDoPedido ? "gray.400" : "orange.600"} textTransform="uppercase" letterSpacing="0.06em">{alterado ? `de ${qtd}` : 'un.'}</Text>
                    </Flex>
                    {produto.quantidade_taga > 0 && (
                        <DicaSePuder desativado={isMobile} label={`Separar ${produto.quantidade_taga} do estoque TAGA${produto.local_estoque ? ` em ${produto.local_estoque}` : ''}`}>
                            <Flex direction={{ base: "row", md: "column" }} align="center" justify="center" wrap={{ base: "wrap", md: "nowrap" }} gap={{ base: 1, md: 0 }} w={{ md: "100%" }} mt={{ md: 1.5 }}
                                px={{ base: 2.5, md: 1 }} py={{ base: 1, md: 1.5 }} borderRadius="lg" bg="red.50" border="1px solid" borderColor="red.100" lineHeight="1">
                                <Text fontSize={{ base: "14px", md: "16px" }} fontWeight="800" color="red.600" sx={NUMEROS}>{produto.quantidade_taga}</Text>
                                <Text fontSize="10px" fontWeight="600" color="red.500" textTransform="uppercase" letterSpacing="0.06em" mt={{ md: 0.5 }}>TAGA</Text>
                                {produto.local_estoque && (
                                    <Box mt={{ md: 1 }} pt={{ md: 1 }} borderTop={{ md: "1px solid" }} borderColor="red.100" w={{ md: "100%" }}>
                                        {String(produto.local_estoque).split('|').map((pos) => pos.trim()).filter(Boolean).map((pos, i) => (
                                            <Text key={i} fontSize="10px" fontFamily="mono" fontWeight="700" color="red.700" textAlign="center" lineHeight="1.3" overflowWrap="anywhere">{pos}</Text>
                                        ))}
                                    </Box>
                                )}
                            </Flex>
                        </DicaSePuder>
                    )}
                </Flex>

                <Flex gridColumn={{ base: "2", md: "auto" }} direction="column" align={{ base: "flex-start", md: "flex-end" }} gap={0.5} textAlign={{ base: "left", md: "right" }} mt={{ base: -1, md: 0 }}>
                    {temPromo && !alterado && <Text fontSize="12px" color="gray.400" textDecoration="line-through" lineHeight="1.2" sx={NUMEROS}>{brl(produto.preco_original)}</Text>}
                    {alterado && preco !== null && <Text fontSize="12px" color="gray.400" textDecoration="line-through" lineHeight="1.2" sx={NUMEROS}>{brl(preco * qtd)}</Text>}
                    <Text fontSize="15px" fontWeight="700" color={foraDoPedido ? "gray.400" : temPromo ? "green.600" : "gray.900"} whiteSpace="nowrap" sx={NUMEROS}>
                        {preco === null ? '-' : brl(preco * (alterado ? r.efetiva : qtd))}
                    </Text>
                    <Text fontSize="11px" color="gray.500" whiteSpace="nowrap" sx={NUMEROS}>{brl(preco)} / un.</Text>
                    {temPromo && (
                        <Box mt={1.5}>
                            <DicaSePuder desativado={isMobile} label="Abrir promoção">
                                <Selo scheme="green" icone={Tag} as="button" type="button" cursor="pointer" maxW="100%" whiteSpace="normal" h="auto" minH="22px" py="3px" lineHeight="1.2" textAlign="left" _hover={{ bg: "green.100" }}
                                    onClick={(e) => { e.stopPropagation(); window.open(`/promocoes/${produto.promocao_lista_id}`, '_blank'); }}>
                                    {produto.promocao_lista_titulo || "Promo"}
                                </Selo>
                            </DicaSePuder>
                        </Box>
                    )}
                </Flex>
            </Grid>
        );
    };

    const fiscal = (() => {
        if (notaEmitida && (ehMl || ehTagaOuSite)) {
            return <Selo scheme="green" icone={CircleCheck}>Nota emitida</Selo>;
        }
        if (ehMl && notaPendente) {
            return (
                <Flex wrap="wrap" align="center" gap={2}>
                    <Selo scheme="yellow" icone={TriangleAlert}>Nota pendente</Selo>
                    {loadingItemsNFML[pedido.id_taga]
                        ? <Spinner size="sm" color="orange.400" />
                        : <Button size="xs" h="26px" px={3} colorScheme="orange" borderRadius="md" leftIcon={<Icon as={FileText} boxSize="13px" />} id={"imprimir_etiqueta_pdf_" + pedido.id_taga}
                            onClick={() => openModalConfirmNF(pedido.id_taga, pedido.id)}>Emitir NF-e</Button>}
                </Flex>
            );
        }
        if (ehTagaOuSite && notaPendente) {
            return (
                <Flex wrap="wrap" align="center" gap={2}>
                    <Selo scheme="yellow" icone={TriangleAlert}>Nota pendente</Selo>
                    <Button size="xs" h="26px" px={3} colorScheme="orange" borderRadius="md" leftIcon={<Icon as={FileText} boxSize="13px" />} id={"emitir_nfe_taga_" + pedido.id_taga}
                        onClick={() => openModalConfirmNfeTaga(pedido.id_taga)}>Emitir NF-e</Button>
                </Flex>
            );
        }
        return <Text fontSize="12px" color="gray.400">Sem ação fiscal</Text>;
    })();

    const situacao = situacaoPrazo(dataLimiteEnvioAtual);
    const selecionado = checkboxesState.includes(pedido.id);
    const corBorda = marcador ? `${marcador.scheme}.300` : (selecionado ? "orange.300" : "gray.200");

    const renderBotoesAcao = (comVisualizar) => (
        <HStack spacing={1.5}>
            {podeAgir && ehMl && (
                <DicaSePuder desativado={isMobile} label={msgLabel}>
                    <BotaoAcao label={msgLabel} icone={MessageCircle} isMobile={isMobile} tom={statusMsg.tem_historico ? 'laranja' : 'neutro'}
                        contador={statusMsg.nao_lida ? (statusMsg.qtd > 0 ? (statusMsg.qtd > 99 ? '99+' : statusMsg.qtd) : '•') : null}
                        onClick={() => consultarMensagensVendas(pedido.id)} />
                </DicaSePuder>
            )}
            <Notas handleAddObs={handleAddObs} idVenda={pedido.id_taga} handleChangeTextObs={handleChangeTextObs} textObs={textObs} observacoes={pedido.observacoes} handleApagarObs={handleApagarObs}
                gatilho={({ abrir, quantidade }) => (
                    <DicaSePuder desativado={isMobile} label={quantidade > 0 ? "Visualizar observações" : "Adicionar observação"}>
                        <BotaoAcao label={quantidade > 0 ? "Visualizar observações" : "Adicionar observação"} icone={quantidade > 0 ? StickyNote : NotebookPen}
                            isMobile={isMobile} tom={quantidade > 0 ? 'laranja' : 'neutro'} contador={quantidade > 0 ? quantidade : null} onClick={abrir} />
                    </DicaSePuder>
                )} />
            {podeAgir && (
                <Menu placement="bottom-end" isLazy>
                    <DicaSePuder desativado={isMobile} label={marcador ? `Marcador: ${marcador.texto}` : "Adicionar marcador"}>
                        <MenuButton as={BotaoAcao} label="Marcador" icone={marcador ? marcador.icone : Bookmark} isMobile={isMobile}
                            tom={marcador ? { bg: `${marcador.scheme}.500`, color: "white", borda: `${marcador.scheme}.500`, hover: `${marcador.scheme}.600` } : 'neutro'} />
                    </DicaSePuder>
                    <Portal>
                        <MenuList zIndex={1500} fontSize="sm" py={1.5} minW="240px" borderRadius="lg" boxShadow="lg">
                            <Text px={3} pb={1.5} pt={0.5} fontSize="10px" fontWeight="700" letterSpacing="0.08em" textTransform="uppercase" color="gray.500">Marcador</Text>
                            {Object.entries(MARCADORES).map(([valor, m]) => {
                                const ativo = Number(valor) === Number(pedido.marcador);
                                return (
                                    <MenuItem key={valor} fontWeight={ativo ? "700" : "500"} bg={ativo ? `${m.scheme}.50` : undefined}
                                        onClick={() => handleMarcadorTaga(pedido.id_taga, Number(valor))}
                                        icon={<Box w="22px" h="22px" borderRadius="md" bg={`${m.scheme}.500`} color="white" display="grid" placeItems="center"><Icon as={m.icone} boxSize="13px" /></Box>}>
                                        {m.texto}
                                    </MenuItem>
                                );
                            })}
                            <MenuDivider />
                            <MenuItem isDisabled={!marcador} color="gray.600" onClick={() => handleMarcadorTaga(pedido.id_taga, 7)}
                                icon={<Box w="22px" h="22px" borderRadius="md" bg="gray.100" color="gray.600" display="grid" placeItems="center"><Icon as={CircleX} boxSize="13px" /></Box>}>
                                Remover marcador
                            </MenuItem>
                        </MenuList>
                    </Portal>
                </Menu>
            )}
            {podeAgir && comVisualizar && (
                <DicaSePuder desativado={isMobile} label="Visualizar pedido">
                    <BotaoAcao label="Visualizar pedido" icone={Eye} isMobile={isMobile} onClick={() => setDetalhesAberto(true)} />
                </DicaSePuder>
            )}
            {podeAgir && (
                <Menu isOpen={menuAberto} onClose={() => { if (menuAberto) toggleMenu(pedido.id); }} closeOnSelect={false} placement="bottom-end" isLazy>
                    <MenuButton as={BotaoAcao} label="Ações" icone={EllipsisVertical} isMobile={isMobile} onClick={() => toggleMenu(pedido.id)} />
                    <Portal>
                        <MenuList zIndex={1500} fontSize="sm" maxH="380px" overflowY="auto" py={1.5} minW="240px" borderRadius="lg" boxShadow="lg">
                            <MenuGroup title="Cotação" fontSize="10px" fontWeight="700" letterSpacing="0.08em" textTransform="uppercase" color="gray.500">
                                <MenuItem onClick={() => handleChangeAcaoIndiv(pedido.id, "lista_cotacao")}>Gerar lista</MenuItem>
                                <MenuItem onClick={() => handleChangeAcaoIndiv(pedido.id, "set_cotacao_sim")}>Marcar cotada(s)</MenuItem>
                                <MenuItem onClick={() => handleChangeAcaoIndiv(pedido.id, "set_cotacao_nao")}>Desmarcar cotada(s)</MenuItem>
                            </MenuGroup>
                            <MenuDivider />
                            <MenuGroup title="Furo de estoque" fontSize="10px" fontWeight="700" letterSpacing="0.08em" textTransform="uppercase" color="gray.500">
                                <MenuItem onClick={() => handleChangeAcaoIndiv(pedido.id, "set_furo_estoque_sim")}>Marcar furo de estoque</MenuItem>
                                <MenuItem onClick={() => handleChangeAcaoIndiv(pedido.id, "set_furo_estoque_nao")}>Desmarcar furo de estoque</MenuItem>
                            </MenuGroup>
                            <MenuDivider />
                            <MenuGroup title="Status da venda" fontSize="10px" fontWeight="700" letterSpacing="0.08em" textTransform="uppercase" color="gray.500">
                                <MenuItem onClick={() => handleChangeAcaoIndiv(pedido.id_taga, "status_venda_1")}>Confirmada</MenuItem>
                                <MenuItem onClick={() => handleChangeAcaoIndiv(pedido.id_taga, "status_venda_2")}>Para enviar</MenuItem>
                                <MenuItem onClick={() => handleChangeAcaoIndiv(pedido.id_taga, "status_venda_3")}>Em trânsito</MenuItem>
                                <MenuItem onClick={() => handleChangeAcaoIndiv(pedido.id_taga, "status_venda_4")}>Concluída</MenuItem>
                                <MenuItem onClick={() => handleChangeAcaoIndiv(pedido.id_taga, "status_venda_5")}>Cancelada</MenuItem>
                            </MenuGroup>
                            <MenuDivider />
                            <MenuGroup title="Status TAGA" fontSize="10px" fontWeight="700" letterSpacing="0.08em" textTransform="uppercase" color="gray.500">
                                <MenuItem fontWeight="600" color="green.600" onClick={() => handleChangeAcaoIndiv(pedido.id, "set_status_taga_sim")}>Confirmada</MenuItem>
                                <MenuItem fontWeight="600" color="red.600" onClick={() => handleChangeAcaoIndiv(pedido.id, "set_status_taga_nao")}>Cancelada</MenuItem>
                                <MenuItem fontWeight="600" color="yellow.600" onClick={() => handleChangeAcaoIndiv(pedido.id, "set_status_taga_pen")}>Pendente</MenuItem>
                            </MenuGroup>
                            {isEntregaCombinar && (
                                <>
                                    <MenuDivider />
                                    <MenuGroup title="Entrega a combinar" fontSize="10px" fontWeight="700" letterSpacing="0.08em" textTransform="uppercase" color="gray.500">
                                        <MenuItem fontWeight="600" color="orange.700" onClick={() => { toggleMenu(null); handleOpenEntregaModal(); }}>Confirmar dados de entrega</MenuItem>
                                    </MenuGroup>
                                </>
                            )}
                            <MenuDivider />
                            <MenuGroup title="Ticket" fontSize="10px" fontWeight="700" letterSpacing="0.08em" textTransform="uppercase" color="gray.500">
                                <MenuItem onClick={() => openTicketModal(pedido)}>Criar ticket de problema</MenuItem>
                            </MenuGroup>
                        </MenuList>
                    </Portal>
                </Menu>
            )}
        </HStack>
    );

    return (
        <>
            {!somenteFicha && (
            <Box w="100%" bg="white" border="1px solid" borderColor={corBorda} borderRadius="xl" overflow="hidden" position="relative"
                boxShadow={selecionado ? "0 0 0 3px rgba(246, 134, 51, 0.18)" : SOMBRA} mb={isInPackGroup ? 2 : 4}
                transition="box-shadow .15s ease, border-color .15s ease" _hover={{ boxShadow: selecionado ? "0 0 0 3px rgba(246, 134, 51, 0.18)" : SOMBRA_HOVER }}>
                <Box position="absolute" left={0} top={0} bottom={0} w="4px" bg={marcador ? `${marcador.scheme}.500` : LARANJA} zIndex={1} />

                <Box px={{ base: 3, md: 5 }} pt={3} pb={2.5} bg={marcador ? `${marcador.scheme}.50` : "#FFF6EE"} borderBottom="1px solid" borderColor={marcador ? `${marcador.scheme}.100` : "orange.100"}>
                    <Flex align="center" gap={3} wrap={{ base: "wrap", lg: "nowrap" }}>
                        <HStack spacing={2.5} minW={0} flex="1 1 auto" flexWrap="wrap" rowGap={1.5}>
                            <Checkbox isChecked={selecionado} onChange={() => handleCheckboxChange(pedido.id)} id={`checkbox-${pedido.id}`} size={isMobile ? "lg" : "md"} colorScheme="orange" />
                            <Canal pedido={pedido} isMobile={isMobile} />
                            <Box minW={0}>
                                <HStack spacing={1}>
                                    <Link href={ehMl ? `https://www.mercadolivre.com.br/vendas/${pedido.id}/detalhe?` : undefined} isExternal={ehMl}
                                        fontSize={{ base: "15px", md: "16px" }} fontWeight="700" color="gray.900" letterSpacing="-0.01em" whiteSpace="nowrap" sx={NUMEROS}
                                        _hover={ehMl ? { color: "blue.600" } : { textDecoration: "none" }}>
                                        #{numeroPedido}
                                    </Link>
                                    <BotaoCopiar valor={numeroPedido} onCopiar={handleClickCopyPedido} label="Copiar número do pedido" />
                                </HStack>
                                {pedido.pack_id && (
                                    <HStack spacing={0.5} h="18px">
                                        <Text fontSize="11px" fontWeight="600" color="blue.600" lineHeight="1.2" sx={NUMEROS}>Pack #{pedido.pack_id}</Text>
                                        <BotaoCopiar valor={pedido.pack_id} onCopiar={handleClickCopyPedido} label="Copiar número do pack" tamanho="11px" />
                                    </HStack>
                                )}
                            </Box>
                        </HStack>

                        <HStack spacing={{ base: 1.5, md: 2 }} flex="none" ml={{ base: 0, lg: "auto" }} w={{ base: "100%", lg: "auto" }} justify={{ base: "space-between", lg: "flex-end" }}>
                            <HStack spacing={1.5} color="gray.500" mr={{ lg: 1 }}>
                                <Icon as={Clock} boxSize="13px" />
                                <Text fontSize="12px" whiteSpace="nowrap" sx={NUMEROS}>{pedido.data_hora}</Text>
                            </HStack>
                            {renderBotoesAcao(true)}
                        </HStack>
                    </Flex>

                    <Flex wrap="wrap" gap={1.5} align="center" mt={2.5} pl={{ base: 0, md: 0 }}>
                        {statusTaga && (
                            <DicaSePuder desativado={isMobile} label="Status TAGA">
                                <Selo scheme={statusTaga.scheme} forte ponto>TAGA · {statusTaga.texto}</Selo>
                            </DicaSePuder>
                        )}
                        {statusMkt && (
                            <DicaSePuder desativado={isMobile} label={`Status no ${CANAIS[pedido.origem]?.nome || 'marketplace'}`}>
                                <Selo scheme={statusMkt.scheme} icone={statusMkt.icone}>{CANAIS[pedido.origem]?.sigla === 'SITE' ? 'Site' : (CANAIS[pedido.origem]?.sigla || 'Canal')} · {statusMkt.texto}</Selo>
                            </DicaSePuder>
                        )}
                        {!vendaCancelada && <DicaSePuder desativado={isMobile} label="Prazo de envio (clique para editar)">
                            <Selo as="button" type="button" cursor="pointer" icone={Clock}
                                scheme={situacao === "vencido" ? "red" : situacao === "futuro" ? "yellow" : "gray"}
                                _hover={{ filter: "brightness(0.97)" }} onClick={(e) => { e.stopPropagation(); handleOpenPrazoModal(); }}>
                                {situacao === "vencido" ? "Atrasado · " : "Enviar até "}{dataLimiteEnvioAtual}
                                <Icon as={Pencil} boxSize="11px" opacity={0.7} />
                            </Selo>
                        </DicaSePuder>}
                        {pedido.vendedor && (
                            <DicaSePuder desativado={isMobile} label="Vendedor responsável">
                                <Selo scheme="purple" pl="3px">
                                    <Box as="span" w="16px" h="16px" borderRadius="full" bg="purple.500" color="white" display="grid" placeItems="center" fontSize="9px" fontWeight="800">
                                        {String(pedido.vendedor.name || '?').charAt(0).toUpperCase()}
                                    </Box>
                                    {pedido.vendedor.name}
                                </Selo>
                            </DicaSePuder>
                        )}
                        {Number(pedido.flex) === 1 && (
                            <DicaSePuder desativado={isMobile} label="Pedido com envio Flex">
                                <Flex as="span" align="center" h="22px" px={1} bg="white" borderRadius="full" border="1px solid" borderColor="green.200">
                                    <Image loading="lazy" decoding="async" src="/logo_flex_ml.webp" alt="Flex" h="16px" w="auto" />
                                </Flex>
                            </DicaSePuder>
                        )}
                        {valores.cancelados > 0 && valores.cancelados + valores.devolvidos < valores.bruto && <Selo scheme="red" icone={CircleX}>Item cancelado</Selo>}
                        {valores.devolvidos > 0 && valores.cancelados + valores.devolvidos < valores.bruto && <Selo scheme="purple" icone={Undo2}>Devolução parcial</Selo>}
                        {cotacao && (
                            <DicaSePuder desativado={isMobile} label="Abrir cotação">
                                <Selo as="button" type="button" cursor="pointer" scheme={cotacao.scheme} icone={ExternalLink} _hover={{ filter: "brightness(0.97)" }}
                                    onClick={(e) => { e.stopPropagation(); window.open(`/cotacoes/${cotacaoStatus.token}`, '_blank', 'noopener'); }}>
                                    Cotação · {cotacao.label}
                                </Selo>
                            </DicaSePuder>
                        )}
                    </Flex>
                </Box>

                {marcador && (
                    <Flex align="center" gap={2} px={{ base: 3, md: 5 }} py={1.5} bg={`${marcador.scheme}.500`} color="white">
                        <Icon as={marcador.icone} boxSize="15px" strokeWidth={2.25} />
                        <Text fontSize="12px" fontWeight="700" letterSpacing="0.06em" textTransform="uppercase">{marcador.texto}</Text>
                    </Flex>
                )}

                <Grid templateColumns={{ base: "1fr", lg: "minmax(0, 1fr) 288px", xl: "minmax(0, 1fr) 210px 170px 190px" }}>
                    <Flex direction="column" minW={0}>
                        <Grid templateColumns={COLUNAS_ITEM} columnGap={{ base: 3, md: 4 }} alignItems="center" px={{ base: 3, md: 5 }} pt={3} pb={1} h="calc(24px + 0.75rem + 0.25rem)" color="gray.500">
                            <HStack spacing={1.5} gridColumn={{ base: "1 / -1", md: "1 / 3" }} color={COR_ROTULO}>
                                <Icon as={Package} boxSize="13px" strokeWidth={2.25} />
                                <Text {...ROTULO_SECAO}>Produtos</Text>
                                <Box as="span" px={1.5} borderRadius="full" bg="orange.100" color="orange.700" fontSize="10px" fontWeight="700" sx={NUMEROS}>{(pedido.produtos || []).length}</Box>
                            </HStack>
                            <Text {...ROTULO_SECAO} textAlign="center" display={{ base: "none", md: "block" }}>Qtd</Text>
                            <Text {...ROTULO_SECAO} textAlign="right" display={{ base: "none", md: "block" }}>Valor</Text>
                        </Grid>
                        <Box position="relative">
                            <Box ref={refLista} maxH={alturaLista ? `${alturaLista + 34}px` : undefined} overflowY={alturaLista ? "auto" : "visible"} sx={ROLAGEM_ITENS}
                                onScroll={(e) => { const el = e.currentTarget; setFimLista(el.scrollTop + el.clientHeight >= el.scrollHeight - 4); }}>
                                {(pedido.produtos || []).map(renderItem)}
                            </Box>
                            {alturaLista && !fimLista && (
                                <Flex as="button" type="button" position="absolute" bottom={2} left="50%" transform="translateX(-50%)" align="center" gap={1}
                                    px={2.5} h="22px" borderRadius="full" bg="white" border="1px solid" borderColor="gray.200" boxShadow="sm"
                                    fontSize="11px" fontWeight="600" color="gray.600" _hover={{ bg: "gray.50", color: "gray.800" }} sx={NUMEROS}
                                    onClick={() => refLista.current?.scrollTo({ top: refLista.current.scrollHeight, behavior: "smooth" })}>
                                    +{(pedido.produtos || []).length - 2} {(pedido.produtos || []).length - 2 === 1 ? 'produto' : 'produtos'}
                                    <Icon as={ChevronDown} boxSize="12px" />
                                </Flex>
                            )}
                        </Box>
                        <Box mt="auto" borderTop="1px solid" borderColor="gray.200" bg={FUNDO_LATERAL}>
                            <Flex as="button" type="button" w="100%" align="center" gap={3} px={{ base: 3, md: 5 }} py={2.5} textAlign="left"
                                _hover={{ bg: "gray.100" }} transition="background .15s" onClick={() => toggleAccordionPedidosFooter(pedido.id)} aria-expanded={totalAberto}
                                aria-label="Ver composição do total">
                                {(pedido.produtos || []).length > 1 && (
                                    <HStack spacing={1.5} color="gray.500">
                                        <Icon as={Package} boxSize="14px" />
                                        <Text fontSize="12px" sx={NUMEROS}>{pedido.total_itens} {Number(pedido.total_itens) === 1 ? 'unidade' : 'unidades'}</Text>
                                    </HStack>
                                )}
                                <HStack spacing={2} ml="auto" align="baseline">
                                    <Text fontSize="12px" color="gray.500" fontWeight="500">{valores.temOcorrencia ? 'Total realizado' : 'Total'}</Text>
                                    <Text fontSize="17px" fontWeight="800" color={COR_ROTULO} letterSpacing="-0.01em" sx={NUMEROS}>{brl(valores.temOcorrencia ? valores.realizado : valores.total)}</Text>
                                </HStack>
                                <Icon as={totalAberto ? ChevronUp : ChevronDown} boxSize="16px" color="gray.400" />
                            </Flex>
                            <Collapse in={totalAberto} animateOpacity>
                                <Flex justify="flex-end" px={{ base: 3, md: 5 }} pb={3}>
                                    <Box w={{ base: "100%", md: "300px" }} p={3} bg="white" borderRadius="lg" fontSize="13px" color="gray.600" sx={NUMEROS}>
                                        {pedido.extrato ? (
                                            <LinhasExtrato extrato={pedido.extrato} Linha={LinhaExtrato} />
                                        ) : (<>
                                        <Flex justify="space-between" py={0.5}><Text>{valores.temOcorrencia ? 'Valor bruto dos itens' : 'Subtotal'}</Text><Text fontWeight="600" color="gray.800">{brl(valores.temOcorrencia ? valores.bruto : pedido.subtotal)}</Text></Flex>
                                        {valores.cancelados > 0 && <Flex justify="space-between" py={0.5}><Text>(-) Itens cancelados</Text><Text fontWeight="600" color="red.500">{brl(valores.cancelados)}</Text></Flex>}
                                        {valores.devolvidos > 0 && <Flex justify="space-between" py={0.5}><Text>(-) Itens devolvidos</Text><Text fontWeight="600" color="red.500">{brl(valores.devolvidos)}</Text></Flex>}
                                        <Flex justify="space-between" py={0.5}><Text>{valores.temOcorrencia ? '(-) Descontos' : 'Desconto'}</Text><Text fontWeight="600" color="red.500">{brl(pedido.desconto)}</Text></Flex>
                                        {valores.outros > 0 && <Flex justify="space-between" py={0.5}><Text>(-) Outros reembolsos</Text><Text fontWeight="600" color="red.500">{brl(valores.outros)}</Text></Flex>}
                                        {valores.frete !== 0 && <Flex justify="space-between" py={0.5}><Text>Frete</Text><Text fontWeight="600" color="gray.800">{brl(valores.frete)}</Text></Flex>}
                                        </>)}
                                        <Flex justify="space-between" pt={2} mt={1.5} borderTop="1px solid" borderColor="gray.200" fontWeight="800" color="gray.900">
                                            <Text>{valores.temOcorrencia ? 'Total realizado' : 'Total'}</Text>
                                            <Text>{brl(valores.temOcorrencia ? valores.realizado : valores.total)}</Text>
                                        </Flex>
                                    </Box>
                                </Flex>
                            </Collapse>
                        </Box>
                    </Flex>
                    <Grid templateColumns={{ base: "repeat(2, minmax(0, 1fr))", lg: "1fr" }} alignContent="start" bg={FUNDO_LATERAL} display={{ base: "grid", xl: "contents" }}
                        borderStyle="solid" borderWidth={0} borderLeftWidth={{ base: 0, lg: "1px" }} borderTopWidth={{ base: "1px", lg: 0 }} borderColor="gray.200">
                        <Secao primeiro emLinha gridColumn={{ base: "1 / -1", lg: "auto" }} titulo="Cliente" icone={User} acao={
                            <DicaSePuder desativado={isMobile} label="Editar cliente">
                                <IconButton aria-label="Editar cliente" icon={<Icon as={Pencil} boxSize="13px" />} size="xs" variant="ghost" color="gray.400" borderRadius="md"
                                    _hover={{ color: "gray.700", bg: "gray.100" }} onClick={handleOpenClienteModal} />
                            </DicaSePuder>
                        }>
                            {clienteAtual ? (
                                <VStack align="stretch" spacing={1}>
                                    {(clienteAtual.nome || clienteAtual.nickname) && (
                                        <Box mb={0.5}>
                                            <Text fontSize="13px" fontWeight="600" color="gray.900" lineHeight="1.3" wordBreak="break-word">{clienteAtual.nome || clienteAtual.nickname}</Text>
                                            {clienteAtual.nome && clienteAtual.nickname && clienteAtual.nickname !== clienteAtual.nome && (
                                                <Text fontSize="11px" color="gray.500" wordBreak="break-word">{clienteAtual.nickname}</Text>
                                            )}
                                        </Box>
                                    )}
                                    {clienteAtual.telefone && <LinhaContato icone={Phone}>{formatPhone(clienteAtual.telefone)}</LinhaContato>}
                                    {clienteAtual.email && <LinhaContato icone={Mail}>{clienteAtual.email}</LinhaContato>}
                                    {clienteAtual.documento && <LinhaContato icone={IdCard}>{formatarDocumento(clienteAtual.documento)}</LinhaContato>}
                                </VStack>
                            ) : (
                                <Text fontSize="12px" color="gray.400">Sem dados do cliente</Text>
                            )}
                        </Secao>

                        <Secao emLinha titulo="Fiscal" icone={FileText}>{fiscal}</Secao>

                        <Secao bordaCelular emLinha titulo="Envio" icone={Truck}>
                            <VStack align="stretch" spacing={2}>
                                {pedido.envio?.modo_envio && (
                                    <Box>
                                        {isEntregaCombinar ? (
                                            <DicaSePuder desativado={isMobile} label="Confirmar dados de entrega">
                                                <Text as="button" type="button" textAlign="left" fontSize="13px" fontWeight="600" color="red.600" display="inline-flex" alignItems="center" gap={1}
                                                    _hover={{ textDecoration: "underline" }} onClick={handleOpenEntregaModal}>
                                                    {pedido.envio.modo_envio}<Icon as={Pencil} boxSize="11px" />
                                                </Text>
                                            </DicaSePuder>
                                        ) : (
                                            <Text fontSize="13px" fontWeight="600" color="gray.900">{pedido.envio.modo_envio}</Text>
                                        )}
                                        {pedido.envio?.empresa && <Text fontSize="12px" color="gray.500">{pedido.envio.empresa}</Text>}
                                    </Box>
                                )}
                                {!pedido.envio?.modo_envio && pedido.envio?.empresa && <Text fontSize="12px" color="gray.600">{pedido.envio.empresa}</Text>}
                                {(isColetaMl(pedido.envio) || (isEntregaCombinar && avisoEntregaMl)) && (
                                    <Flex wrap="wrap" gap={1.5}>
                                        {isColetaMl(pedido.envio) && (
                                            <DicaSePuder desativado={isMobile} label="Coleta: a transportadora do Mercado Livre retira o pacote aqui na TAGA">
                                                <Selo scheme="pink" icone={Truck}>Coleta</Selo>
                                            </DicaSePuder>
                                        )}
                                        {isEntregaCombinar && avisoEntregaMl && (
                                            <DicaSePuder desativado={isMobile} label={avisoEntregaMl.descricao}>
                                                <Selo scheme={avisoEntregaMl.scheme} icone={avisoEntregaMl.icone} whiteSpace="normal" h="auto" minH="22px" py="4px" lineHeight="1.2">{avisoEntregaMl.rotulo}</Selo>
                                            </DicaSePuder>
                                        )}
                                    </Flex>
                                )}
                                {(ehMl && (pedido.pode_imprimir_etiqueta === true || Number(pedido.pode_imprimir_etiqueta) === 1)) && (
                                    loadingItemsEtiqueta[pedido.id_taga] ? (
                                        <Spinner size="sm" color="orange.400" />
                                    ) : (
                                        <HStack spacing={1.5}>
                                            <Button size="xs" h="26px" variant="outline" bg="white" borderColor="gray.300" color="gray.700" borderRadius="md" leftIcon={<Icon as={Download} boxSize="12px" />}
                                                id={"imprimir_etiqueta_pdf_" + pedido.id_taga} onClick={() => handleClickImprimirEtiqueta(pedido.id_taga, "pdf", pedido.id)}>Etiqueta PDF</Button>
                                            <Button size="xs" h="26px" variant="outline" bg="white" borderColor="gray.300" color="gray.700" borderRadius="md" leftIcon={<Icon as={Download} boxSize="12px" />}
                                                id={"imprimir_etiqueta_zpl2_" + pedido.id_taga} onClick={() => handleClickImprimirEtiqueta(pedido.id_taga, "zpl2", pedido.id)}>ZPL</Button>
                                        </HStack>
                                    )
                                )}
                                {(ehTagaOuSite || isEntregaCombinar) && (
                                    <Box><GeradorEtiquetaMelhorEnvio venda={pedido} comTexto /></Box>
                                )}
                            </VStack>
                        </Secao>
                    </Grid>
                </Grid>

            </Box>
            )}

            {detalhesAberto && (
                <DetalhesVendaModal isOpen={detalhesAberto} onClose={() => { setDetalhesAberto(false); if (somenteFicha && onFecharFicha) onFecharFicha(); }} pedido={pedido} isMobile={isMobile} versao={versaoDetalhes}
                    acoes={somenteFicha ? renderBotoesAcao(false) : null}
                    renderSelosItem={somenteFicha ? (produto) => <SelosOcorrenciasItem pedido={pedido} produto={produto} acoes={acoesItem} podeAgir={podeAgir} Selo={SeloOcorrencia} desativarDica={isMobile} /> : null}
                    onEditarCliente={handleOpenClienteModal}
                    onEditarPrazo={handleOpenPrazoModal}
                    onEmitirNota={notaPendente ? (ehMl ? () => openModalConfirmNF(pedido.id_taga, pedido.id) : ehTagaOuSite ? () => openModalConfirmNfeTaga(pedido.id_taga) : null) : null}
                    emitindoNota={!!loadingItemsNFML[pedido.id_taga]}
                    onImprimirEtiqueta={(ehMl && (pedido.pode_imprimir_etiqueta === true || Number(pedido.pode_imprimir_etiqueta) === 1)) ? (tipo) => handleClickImprimirEtiqueta(pedido.id_taga, tipo, pedido.id) : null}
                    imprimindoEtiqueta={!!loadingItemsEtiqueta[pedido.id_taga]}
                    onConfirmarEntrega={isEntregaCombinar ? handleOpenEntregaModal : null} />
            )}

            <Modal isOpen={!!imagemAmpliada} onClose={() => setImagemAmpliada(null)} size={{ base: "full", md: "xl" }} isCentered>
                <ModalOverlay bg="blackAlpha.700" />
                <ModalContent borderRadius={{ base: 0, md: "xl" }} overflow="hidden">
                    <ModalHeader fontSize="md" pr={12} noOfLines={2}>{imagemAmpliada?.nome}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody display="flex" justifyContent="center" alignItems="center" bg="gray.50" py={6}>
                        {imagemAmpliada && (
                            <ProdutoImagem produto={imagemAmpliada} origem="" width={isMobile ? "88vw" : "480px"} height={isMobile ? "88vw" : "480px"} />
                        )}
                    </ModalBody>
                    <ModalFooter justifyContent="space-between" gap={3} flexWrap="wrap">
                        <Text fontSize="12px" color="gray.500">SKU <Text as="span" fontFamily="mono" fontWeight="600" color="gray.800">{imagemAmpliada?.id}</Text></Text>
                        {ehMl && imagemAmpliada?.id_ml && (
                            <Button as={Link} href={linkAnuncioMl(imagemAmpliada.id_ml)} isExternal size="sm" variant="outline" borderRadius="md"
                                rightIcon={<Icon as={ExternalLink} boxSize="13px" />} _hover={{ textDecoration: "none", bg: "gray.50" }}>
                                Abrir anúncio no Mercado Livre
                            </Button>
                        )}
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Modal isOpen={isClienteModalOpen} onClose={onClienteModalClose} size="md" isCentered>
                <ModalOverlay />
                <ModalContent mx={{ base: 3, md: 0 }}>
                    <ModalHeader fontSize="md">Editar Dados do Cliente</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <VStack spacing={3}>
                            <FormControl isRequired>
                                <FormLabel fontSize="sm">Nome</FormLabel>
                                <Input size="sm" value={clienteForm.nome} onChange={(e) => setClienteForm(prev => ({ ...prev, nome: e.target.value }))} placeholder="Nome completo" />
                            </FormControl>
                            <FormControl>
                                <FormLabel fontSize="sm">Nickname</FormLabel>
                                <Input size="sm" value={clienteForm.nickname} onChange={(e) => setClienteForm(prev => ({ ...prev, nickname: e.target.value }))} placeholder="Nickname / apelido" />
                            </FormControl>
                            <FormControl>
                                <FormLabel fontSize="sm">Tipo</FormLabel>
                                <Select size="sm" value={clienteForm.tipo} onChange={(e) => setClienteForm(prev => ({ ...prev, tipo: e.target.value }))}>
                                    <option value="PF">Pessoa Física (PF)</option>
                                    <option value="PJ">Pessoa Jurídica (PJ)</option>
                                </Select>
                            </FormControl>
                            <FormControl>
                                <FormLabel fontSize="sm">{clienteForm.tipo === 'PJ' ? 'CNPJ' : 'CPF'}</FormLabel>
                                <Input size="sm" value={clienteForm.documento} onChange={(e) => setClienteForm(prev => ({ ...prev, documento: e.target.value }))} placeholder={clienteForm.tipo === 'PJ' ? '00.000.000/0000-00' : '000.000.000-00'} />
                            </FormControl>
                            {clienteForm.tipo === 'PJ' && (
                                <FormControl>
                                    <FormLabel fontSize="sm">Inscrição Estadual (IE)</FormLabel>
                                    <Input size="sm" value={clienteForm.ie} onChange={(e) => setClienteForm(prev => ({ ...prev, ie: e.target.value }))} placeholder="000.000.000.000" />
                                </FormControl>
                            )}
                            <FormControl>
                                <FormLabel fontSize="sm">E-mail</FormLabel>
                                <Input size="sm" value={clienteForm.email} onChange={(e) => setClienteForm(prev => ({ ...prev, email: e.target.value }))} placeholder="email@exemplo.com" />
                            </FormControl>
                            <FormControl>
                                <FormLabel fontSize="sm">Telefone</FormLabel>
                                <Input size="sm" value={clienteForm.telefone} onChange={(e) => setClienteForm(prev => ({ ...prev, telefone: e.target.value }))} placeholder="(00) 00000-0000" />
                            </FormControl>
                        </VStack>
                    </ModalBody>
                    <ModalFooter gap={2}>
                        <Button size="sm" variant="ghost" onClick={onClienteModalClose} isDisabled={savingCliente}>Cancelar</Button>
                        <Button size="sm" colorScheme="orange" onClick={handleSalvarCliente} isLoading={savingCliente}>Salvar</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Modal isOpen={isEntregaModalOpen} onClose={onEntregaModalClose} size={{ base: "full", md: "xl" }} isCentered>
                <ModalOverlay />
                <ModalContent mx={{ base: 0, md: 3 }}>
                    <ModalHeader fontSize="md">Confirmar Dados de Entrega</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text fontSize="xs" color="gray.500" mb={3}>
                            Venda "Entrega a Combinar". Preencha os dados combinados com o cliente. Eles serão usados na emissão da etiqueta.
                        </Text>
                        {loadingEntrega ? (
                            <Flex justify="center" py={6}><Spinner color="orange.400" /></Flex>
                        ) : (
                            <Grid templateColumns="repeat(12, 1fr)" gap={3}>
                                <GridItem colSpan={{ base: 12, md: 8 }}>
                                    <FormControl isRequired>
                                        <FormLabel fontSize="sm">Nome do Cliente</FormLabel>
                                        <Input size="sm" value={entregaForm.nome} onChange={(e) => setEntregaForm(prev => ({ ...prev, nome: e.target.value }))} placeholder="Nome completo" />
                                    </FormControl>
                                </GridItem>
                                <GridItem colSpan={{ base: 12, md: 4 }}>
                                    <FormControl>
                                        <FormLabel fontSize="sm">Telefone</FormLabel>
                                        <Input size="sm" value={entregaForm.telefone} onChange={(e) => setEntregaForm(prev => ({ ...prev, telefone: e.target.value }))} placeholder="(00) 00000-0000" />
                                    </FormControl>
                                </GridItem>
                                <GridItem colSpan={{ base: 12, md: 4 }}>
                                    <FormControl>
                                        <FormLabel fontSize="sm">Tipo</FormLabel>
                                        <Select size="sm" value={entregaForm.tipo} onChange={(e) => setEntregaForm(prev => ({ ...prev, tipo: e.target.value }))}>
                                            <option value="PF">Pessoa Física (PF)</option>
                                            <option value="PJ">Pessoa Jurídica (PJ)</option>
                                        </Select>
                                    </FormControl>
                                </GridItem>
                                <GridItem colSpan={{ base: 12, md: 8 }}>
                                    <FormControl>
                                        <FormLabel fontSize="sm">{entregaForm.tipo === 'PJ' ? 'CNPJ' : 'CPF'}</FormLabel>
                                        <Input size="sm" value={entregaForm.documento} onChange={(e) => setEntregaForm(prev => ({ ...prev, documento: e.target.value }))} placeholder={entregaForm.tipo === 'PJ' ? '00.000.000/0000-00' : '000.000.000-00'} />
                                    </FormControl>
                                </GridItem>
                                <GridItem colSpan={{ base: 12, md: 4 }}>
                                    <FormControl>
                                        <FormLabel fontSize="sm">CEP</FormLabel>
                                        <Input size="sm" value={entregaForm.cep} onChange={(e) => setEntregaForm(prev => ({ ...prev, cep: e.target.value }))} placeholder="00000-000" />
                                    </FormControl>
                                </GridItem>
                                <GridItem colSpan={{ base: 12, md: 8 }}>
                                    <FormControl>
                                        <FormLabel fontSize="sm">Logradouro</FormLabel>
                                        <Input size="sm" value={entregaForm.endereco} onChange={(e) => setEntregaForm(prev => ({ ...prev, endereco: e.target.value }))} placeholder="Rua / Av." />
                                    </FormControl>
                                </GridItem>
                                <GridItem colSpan={{ base: 12, md: 4 }}>
                                    <FormControl>
                                        <FormLabel fontSize="sm">Número</FormLabel>
                                        <Input size="sm" value={entregaForm.numero} onChange={(e) => setEntregaForm(prev => ({ ...prev, numero: e.target.value }))} placeholder="S/N" />
                                    </FormControl>
                                </GridItem>
                                <GridItem colSpan={{ base: 12, md: 6 }}>
                                    <FormControl>
                                        <FormLabel fontSize="sm">Complemento</FormLabel>
                                        <Input size="sm" value={entregaForm.complemento} onChange={(e) => setEntregaForm(prev => ({ ...prev, complemento: e.target.value }))} />
                                    </FormControl>
                                </GridItem>
                                <GridItem colSpan={{ base: 12, md: 6 }}>
                                    <FormControl>
                                        <FormLabel fontSize="sm">Bairro</FormLabel>
                                        <Input size="sm" value={entregaForm.bairro} onChange={(e) => setEntregaForm(prev => ({ ...prev, bairro: e.target.value }))} />
                                    </FormControl>
                                </GridItem>
                                <GridItem colSpan={{ base: 12, md: 9 }}>
                                    <FormControl>
                                        <FormLabel fontSize="sm">Cidade</FormLabel>
                                        <Input size="sm" value={entregaForm.cidade} onChange={(e) => setEntregaForm(prev => ({ ...prev, cidade: e.target.value }))} />
                                    </FormControl>
                                </GridItem>
                                <GridItem colSpan={{ base: 12, md: 3 }}>
                                    <FormControl>
                                        <FormLabel fontSize="sm">UF</FormLabel>
                                        <Input size="sm" maxLength={2} value={entregaForm.uf} onChange={(e) => setEntregaForm(prev => ({ ...prev, uf: e.target.value.toUpperCase() }))} />
                                    </FormControl>
                                </GridItem>
                                <GridItem colSpan={12}>
                                    <FormControl>
                                        <FormLabel fontSize="sm">Transportadora / Modalidade de Envio</FormLabel>
                                        <Input size="sm" value={entregaForm.transportadora} onChange={(e) => setEntregaForm(prev => ({ ...prev, transportadora: e.target.value }))} placeholder="Ex.: Retirada, transportadora X, etc." />
                                    </FormControl>
                                </GridItem>
                            </Grid>
                        )}
                    </ModalBody>
                    <ModalFooter gap={2}>
                        <Button size="sm" variant="ghost" onClick={onEntregaModalClose} isDisabled={savingEntrega}>Cancelar</Button>
                        <Button size="sm" colorScheme="orange" onClick={handleSalvarEntrega} isLoading={savingEntrega} isDisabled={loadingEntrega}>Confirmar</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Modal isOpen={isPrazoModalOpen} onClose={onPrazoModalClose} size={{ base: "xs", md: "sm" }} isCentered>
                <ModalOverlay />
                <ModalContent mx={{ base: 3, md: 0 }}>
                    <ModalHeader fontSize="md">Editar Prazo de Envio</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <FormControl isRequired>
                            <FormLabel fontSize="sm">Nova data limite</FormLabel>
                            <Input size="sm" type="datetime-local" value={prazoForm}
                                min={(() => {
                                    const n = new Date();
                                    const p = (x) => String(x).padStart(2, '0');
                                    return `${n.getFullYear()}-${p(n.getMonth() + 1)}-${p(n.getDate())}T${p(n.getHours())}:${p(n.getMinutes())}`;
                                })()}
                                onChange={(e) => setPrazoForm(e.target.value)} />
                        </FormControl>
                    </ModalBody>
                    <ModalFooter gap={2}>
                        <Button size="sm" variant="ghost" onClick={onPrazoModalClose} isDisabled={savingPrazo}>Cancelar</Button>
                        <Button size="sm" colorScheme="orange" onClick={handleConfirmarPrazo} isDisabled={savingPrazo}>Salvar</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Modal isOpen={isPrazoConfirmOpen} onClose={onPrazoConfirmClose} isCentered>
                <ModalOverlay />
                <ModalContent mx={{ base: 3, md: 0 }}>
                    <ModalHeader>Confirmação</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text fontSize="16" mb={4}>
                            Tem certeza de que deseja alterar o prazo de envio da venda <b>#{pedido.id_taga ?? pedido.id}</b> para <b>{prazoConfirmacaoTexto}</b>?
                        </Text>
                        <Text fontSize="sm" color="gray.600">
                            Essa data não será mais sobrescrita pelas sincronizações automáticas do Mercado Livre.
                        </Text>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="green" mr={3} onClick={handleSalvarPrazo} isLoading={savingPrazo}>Confirmar</Button>
                        <Button variant="ghost" onClick={onPrazoConfirmClose} isDisabled={savingPrazo}>Cancelar</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {modalListaInfo && (
                <AdicionarItemListaModal
                    isOpen={!!modalListaInfo}
                    onClose={() => setModalListaInfo(null)}
                    itemVendaId={modalListaInfo.itemVendaId}
                    fornecedorId={modalListaInfo.fornecedorId}
                    fornecedorNome={modalListaInfo.fornecedorNome}
                    produtoNome={modalListaInfo.produtoNome}
                    statusAtual={modalListaInfo.statusAtual}
                    onUpdated={handleListaUpdated}
                />
            )}
            {acoesItem.modais}
        </>
    );
};

const arePropsEqual = (prevProps, nextProps) => {
    const id = prevProps.pedido.id;
    const idTaga = prevProps.pedido.id_taga;

    if (prevProps.pedido !== nextProps.pedido) return false;
    if (prevProps.checkboxesState.includes(id) !== nextProps.checkboxesState.includes(id)) return false;
    if ((prevProps.menuVisivel === id) !== (nextProps.menuVisivel === id)) return false;
    if (prevProps.loadingItemsNFML[idTaga] !== nextProps.loadingItemsNFML[idTaga]) return false;
    if (prevProps.loadingItemsEtiqueta[idTaga] !== nextProps.loadingItemsEtiqueta[idTaga]) return false;

    const packKey = String(prevProps.pedido.pack_id);
    if ((prevProps.naoLidasPorPackId || {})[packKey] !== (nextProps.naoLidasPorPackId || {})[packKey]) return false;
    if (prevProps.openPedidosFooter[id] !== nextProps.openPedidosFooter[id]) return false;
    if (prevProps.textObs !== nextProps.textObs) return false;

    if (prevProps.marcador !== nextProps.marcador) return false;
    if (prevProps.cotada !== nextProps.cotada) return false;
    if (prevProps.furo_estoque !== nextProps.furo_estoque) return false;
    if (prevProps.status_taga !== nextProps.status_taga) return false;
    if (prevProps.status !== nextProps.status) return false;
    if (prevProps.notaEmitida !== nextProps.notaEmitida) return false;
    if (prevProps.observacoes !== nextProps.observacoes) return false;
    if (prevProps.loadingMini !== nextProps.loadingMini) return false;
    if (prevProps.isMobile !== nextProps.isMobile) return false;

    const prevCot = prevProps.cotacaoStatus;
    const nextCot = nextProps.cotacaoStatus;
    if (prevCot !== nextCot) {
        if (!prevCot || !nextCot) return false;
        if (prevCot.status !== nextCot.status || prevCot.token !== nextCot.token) return false;
    }
    return true;
};

export default memo(VendaCardV2, arePropsEqual);
